module.exports = __webpack_public_path__ + "public/img/hgd-txt.f2fcab5d.png";